import * as React from "react";
import { IPickerItemProps, Label, TagItem, TagPicker, nuOrderTheme as theme, ITag } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { FOLDERS } from "constants/integration/folders";
import { useFetchBrandsForAssortment } from "containers/folders/hooks/brands";
import { ActionsTypes, useAssortmentDialogContext } from "./context";

// TODO: remove the styles from styles inline and passing them to a variable
const RenderTag = (props: IPickerItemProps<any>) => {
    if (props?.item) {
        return (
            <TagItem
                {...props}
                key={props.item._id}
                styles={{
                    close: {
                        "& svg": {
                            height: 16,
                            width: 16,
                            fill: theme.palette.greyDark,
                        },
                        "&:hover": {
                            svg: {
                                fill: theme.palette.black,
                            },
                        },
                    },
                }}
            >
                {props.item.name}
            </TagItem>
        );
    }
    return null;
};

interface TagIdentity extends ITag {
    _id: string;
}
const filterTagList = (list: ITag[]) => (filterText: string) =>
    filterText ? list.filter((tag) => tag.name.toLowerCase().includes(filterText.toLowerCase())) : [];

export const BrandPicker = () => {
    const { data: brands, isLoading: isLoadingBrands } = useFetchBrandsForAssortment();
    const { dispatch, formValues, isEditing } = useAssortmentDialogContext();

    const handleChangeBrand = (items?: TagIdentity[]) => {
        dispatch({ type: ActionsTypes.UPDATE_BRAND_ID, payload: items?.[0]?._id ?? null });
    };
    const defaultSelectedItems: ITag[] = isEditing ? [{ name: formValues.brandId, key: formValues.brandId }] : [];
    return (
        <>
            <Label>{formatMessage("Brand")}</Label>
            <TagPicker
                data-test={FOLDERS.CREATE_ASSORTMENT_DIALOG.BRAND_PICKER}
                onResolveSuggestions={filterTagList(brands)}
                defaultSelectedItems={defaultSelectedItems}
                disabled={isEditing}
                itemLimit={1}
                isLoading={isEditing ? false : isLoadingBrands}
                onChange={handleChangeBrand}
                pickerSuggestionsProps={{
                    noResultsFoundText: formatMessage("No results found"),
                }}
                resolveDelay={250}
                loadingText={formatMessage("Loading...")}
                onRenderItem={RenderTag}
            />
        </>
    );
};
